import React, { useContext, useState, useEffect } from "react"
import ReactHtmlParser from "react-html-parser"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import {  Box, Grid, Flex } from 'theme-ui'
import { CanvasContext } from "../hooks/LessonPage"
import {  Modal, Drawer, Input,Typography,Button, Form } from 'antd';
import "./TextElements.scss"


const UrlElement = props => {
      const [form] = Form.useForm();
   const { metadata, id, iseeadonly, dimension, position, type } = props
   const { state, actions } = useContext(CanvasContext)
   const [open, setOpen] = useState(false);
   const [text, setText] = useState("");
   const [urlHtml, setUrlHtml] = useState("");
   const [link, setLink] = useState("");
   const [title, setTitle] = useState("");
   const [targetRef, setTargetRef] = useState(null)
   const elementRef = React.useRef(null)
   const [showGrids, setShowGrids] = React.useState(false)
   const [formLayout, setFormLayout] = useState('vertical');
   const [isBold, setIsBold] = useState(false);
   const [isItalic, setIsItalic] = useState(false);
   const [isUnderline, setIsUnderline] = useState(false);
   const [fontSize, setFontSize] = useState('24');



   useEffect(() => {
      setText(metadata.content)
      var data  = JSON.parse(metadata.content)
      var urlHtml = `<p style="font-size:${data.fontSize}pt" > <a style="cursor : pointer; color: black;" href=${data.urlLink}>${data.urlTitle}</a> </p>`
      if (data.isBold)
          urlHtml = `<b>${urlHtml}</b>`
      if (data.isItalic)
        urlHtml = `<i>${urlHtml}</i>`  
      if (data.isUnderline)
        urlHtml = `<ins>${urlHtml}</ins>`   
      setUrlHtml(urlHtml)

      setIsBold(data.isBold)
      setIsItalic(data.isItalic)
      setIsUnderline(data.isUnderline)
      setFontSize(data.fontSize)
      setLink(data.urlLink)
      setTitle(data.urlTitle)

      form.setFieldsValue({
        urlTitle: data.urlTitle,
        urlLink: data.urlLink
     });
   }, [metadata.content]);




   const onClick = (e) => {
      e.stopPropagation();
      e.preventDefault()
      actions?.setTargetRef(elementRef)
      actions?.setCurrentElementId(id)
      var activeContent = { id: id, type: type, metadata: metadata, dimension: dimension, position: position }
      actions?.setActiveEditable(activeContent)
   }

   const textDoubleClick = (e) => {
      e.stopPropagation();
      setText("")
      setOpen(true)

      setTimeout(function () {
         setText(metadata.content)
      }, 100);

      setTargetRef(state?.targetRef)
      actions.setTargetRef(null)
   }

   const onFinish = (values) => {
      setOpen(false);
      actions.setTargetRef(targetRef)
      var urlData = {urlLink : values.urlLink , urlTitle : values.urlTitle, isBold : isBold , isItalic : isItalic , isUnderline : isUnderline, fontSize : fontSize}
      var datastring = JSON.stringify(urlData);
    //   var data = {type : "URL", url : "", defaultcontent : datastring}      
      var contentData = { id: id, content: datastring }
      actions.updateCanvasData(contentData)
   };

   const handleCancel = () => {
      setOpen(false);
      actions.setTargetRef(targetRef)
      // var contentData = { id :  id, content: text }
      // actions.updateCanvasData(contentData)
   };

   const onEnter = (e, value) => {
      e.stopPropagation()
      e.preventDefault()
      setShowGrids(value)
   }

   const textChange = (text) => {
      setText(text)
   }

   const Editor = () => {
      return (
         <>
            {/* <CustomToolbar/> */}
            <div style={{
               justifyContent: "center", margin: "auto", height: "calc(100vh - 249px)",
               // border: "1px solid #80bdff",
               boxShadow: "0 0 0 0.1rem rgba(51, 52, 52, 0.25)",
               backgroundColor: "#ccc",
               overflow: "auto"
            }}>
                <div style={{
                        width: "100%",
                        height: "50px",
                        margin: "auto",
                        justifyItems: "center",
                        alignItems: "center",
                        textAlign: "center",
                        marginTop: "10px"      
                    }}>
                    <div style={{color : 'white' , fontWeight : 'bold', width : '100%', fontSize : '18px' }}>
                        External Link
                    </div>
                        </div>                  
                {/* </Box> */}
                <div class="editor-container">
                    <div class="toolbar">
                        <button style={{background : isBold ? "#007bff" : "white"}} onClick={() => setIsBold(!isBold)}><b>B</b></button>
                        <button style={{background : isItalic ? "#007bff" : "white"}} onClick={() => setIsItalic(!isItalic)}><i>I</i></button>
                        <button style={{background : isUnderline ? "#007bff" : "white"}} onClick={() => setIsUnderline(!isUnderline)}><u>U</u></button>
                        <select onChange={(e) => setFontSize(e.target.value)}>
                            <option selected={fontSize === "24" ? "selected" : ""} value="24">Normal</option>
                            <option selected={fontSize === "16" ? "selected" : ""} value="16">Small</option>
                            <option selected={fontSize === "36" ? "selected" : ""} value="36">Large</option>
                            <option selected={fontSize === "48" ? "selected" : ""} value="48">Huge</option>
                        </select>
                    </div>
                </div> 

                <Grid sx={{ gridTemplateRows: '50px 50px 50px' }}>
                    <Box sx={{ fontWeight: 600, fontSize: '2rem', margin : "1rem 1rem" }}>
                    <Form
                        layout={formLayout}
                        form={form}
                        initialValues={{
                            layout: formLayout,
                        }}
                        style={{
                            maxWidth: formLayout === 'inline' ? 'none' : 600,
                        }}   
                        onFinish={onFinish}           
                        >     
                        <Form.Item
                        label="Enter title : "
                        name="urlTitle"
                        rules={[{ required: true, message: 'Please enter any value!' }]}
                        >
                           <Input  size="large" placeholder="Enter your title here"/>
                        </Form.Item>              
                        <Form.Item
                        label="Enter your external link :"
                        name="urlLink"
                        rules={[{  pattern: new RegExp(/(https):\/\/([\w.]+\/?)\S*/), required: true, message: 'Please enter a valid link!' }]}
                        >
                           <Input.TextArea />
                        </Form.Item>   

                        <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                        <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: '15px' }}>
                        <Button className='button-shadow' htmlType="submit" type="primary" size="large" shape='round' style={{ marginRight: "5px" }} >
                            Update Text
                        </Button>
                        <Button className='button-shadow' type="primary" size="large" shape='round' onClick={() => setOpen(false)} >
                            Cancel
                        </Button>
                        </div>                            
                        {/* <Button type="primary" htmlType="submit">
                            Submit
                        </Button> */}
                        </Form.Item>                  
                    </Form>
                    </Box>
                </Grid>

            </div>
            {/* <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: '15px' }}>
               <Button className='button-shadow' type="primary" size="large" shape='round' onClick={() => handleOk()} style={{ marginRight: "5px" }} >
                  Update Text
               </Button>
               <Button className='button-shadow' type="primary" size="large" shape='round' onClick={() => setOpen(false)} >
                  Cancel
               </Button>
            </div> */}
         </>
      )
   }


   return (
      <>
         <div
            ref={elementRef}
            onMouseEnter={(e) => onEnter(e, true)}
            onMouseLeave={(e) => onEnter(e, false)}
            onClick={(e) => onClick(e)}
            onDoubleClick={(e) => textDoubleClick(e)}
            style={{
               position: "absolute",
               left: position?.left || 0,
               top: position?.top || 0,
               width: dimension?.width || 0,
               height: dimension?.height || 0,
               transform: dimension?.transform || "translate(1px, 1px)",
               fontFamily: "Arial",
               fontSize: "13px",
               padding: 0,
               float: "left",
               border: `2px solid ${showGrids
                  ? "#21DEE5"
                  : "transparent"
                  }`,
            }}
         >
            <div style={{ height: "100%", width: "100%", textAlign: "left", wordWrap: "break-word" }}>
               {ReactHtmlParser(urlHtml || "")}
            </div>
         </div>

         {/* <Modal
            title="Edit Text"
            centered
            destroyOnClose={true}
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            cancelButtonProps={{ shape: "round" }}
            okButtonProps={{ shape: "round" }}      
      >
         {Editor()}
      </Modal>       */}
         <Drawer title="Update Text" onClose={handleCancel} open={open}>
            {Editor()}
         </Drawer>
      </>
   )
}

export default UrlElement
